import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Linkedin, Twitter, Instagram } from "lucide-react";
import SITE from "@/lib/site";
import Logo from "@/components/site/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#14241F] text-[#D5DDD7] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img src="/ambuly-logo.png" alt="Ambuly" width={40} height={40} className="h-10 w-10 rounded-[10px] object-cover" />
              <span className="font-[Outfit] font-bold text-xl text-white">Ambuly</span>
            </div>
            <p className="mt-4 text-[#D5DDD7]/80 max-w-md">
              Ambuly connects patients, families and hospitals with verified
              ambulance services — fast, transparent, and available 24/7.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <p className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[#E5383B]" /> <span>{SITE.legal.address}</span></p>
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#E5383B]" /> <a data-testid="footer-email" href={`mailto:${SITE.legal.email}`} className="hover:text-white">{SITE.legal.email}</a></p>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold tracking-[0.18em] uppercase">Company</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white">About</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="hover:text-white">Services</Link></li>
              <li><Link data-testid="footer-link-pricing" to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold tracking-[0.18em] uppercase">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms-of-service" className="hover:text-white">Terms of Service</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-semibold tracking-[0.18em] uppercase">24/7 Emergency</h4>
            <p className="mt-4 text-sm text-[#D5DDD7]/80">For medical emergencies, call the local emergency number immediately.</p>
            <a
              href={`tel:${SITE.legal.emergencyLine}`}
              data-testid="footer-emergency-btn"
              className="mt-4 inline-flex items-center justify-center bg-[#E5383B] text-white hover:bg-[#BA1826] rounded-lg px-5 py-3 font-semibold"
            >
              <Phone className="h-4 w-4 mr-2" /> Call {SITE.legal.emergencyLine}
            </a>
            <div className="mt-6 flex items-center gap-3">
              <a href="#" aria-label="LinkedIn" data-testid="social-linkedin" className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-white/20 hover:border-white hover:text-white transition-colors"><Linkedin className="h-4 w-4" /></a>
              <a href="#" aria-label="Twitter" data-testid="social-twitter" className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-white/20 hover:border-white hover:text-white transition-colors"><Twitter className="h-4 w-4" /></a>
              <a href="#" aria-label="Instagram" data-testid="social-instagram" className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-white/20 hover:border-white hover:text-white transition-colors"><Instagram className="h-4 w-4" /></a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-2 text-xs text-[#D5DDD7]/70">
          <p>© {year} {SITE.legal.companyName}. All rights reserved. Ambuly is not a substitute for emergency medical services.</p>
          <p>Built with care — for moments that matter.</p>
        </div>
      </div>
    </footer>
  );
}
